// Navigation items for LAuthorize project

import {
  DashboardIcon,
  HelpCenterIcon,
  MessagesIcon,
  ReportsIcon,
  TaxSettingsIcon,
  TransactionsIcon,
} from '../../components/MainNavigation/icons'
import { getCombinedSettingsMessageCount } from 'utils/settingsNavBadgeCount'
import { SANDBOX_FEATURE } from '../../helpers/sandboxAccess'

/**
 * Get navigation items for LAuthorize project
 * @param {Object} context - Context object with location, t, newMessagesCount
 * @returns {Array} Array of navigation items
 */
export const getLAuthorizeNavigationItems = (context) => {
  const { location, t, newMessagesCount = {} } = context

  const printMessagesCount = (count) => {
    if (count) {
      return count
    }
    return null
  }

  return [
    // {
    //   url: '/home',
    //   label: t('menu.home'),
    //   icon: () => <DashboardIcon selected={location.pathname.startsWith('/home')} />,
    //   selected: location.pathname.startsWith('/home'),
    //   isTaxAgentMainVisible: true,
    // },
    // {
    //   url: '/transactions',
    //   label: t('menu.transactions'),
    //   icon: () => <TransactionsIcon selected={location.pathname.startsWith('/transactions')} />,
    //   badge: printMessagesCount(newMessagesCount.transactions),
    //   selected: location.pathname.startsWith('/transactions'),
    //   isTaxAgentMainVisible: false,
    // },
    {
      url: '/start-guide',
      label: 'Start guide',
      icon: () => <HelpCenterIcon selected={location.pathname.startsWith('/start-guide')} />,
      selected: location.pathname.startsWith('/start-guide'),
      isTaxAgentMainVisible: true,
    },
    {
      url: '/products',
      label: 'Products',
      icon: () => <ReportsIcon selected={location.pathname.startsWith('/products')} />,
      badge: printMessagesCount(newMessagesCount.products),
      selected: location.pathname.startsWith('/products'),
    },
    {
      url: '/packaging',
      label: 'Packaging',
      icon: () => <ReportsIcon selected={location.pathname.startsWith('/packaging')} />,
      selected: location.pathname.startsWith('/packaging'),
    },
    {
      url: '/messages',
      label: t('menu.messages'),
      icon: () => <MessagesIcon selected={location.pathname.startsWith('/messages')} />,
      badge: printMessagesCount(newMessagesCount.messages),
      selected: location.pathname.startsWith('/messages'),
      sandboxFeature: SANDBOX_FEATURE.MESSAGES,
      isTaxAgentMainVisible: true,
    },
    {
      url: '/settings',
      label: 'SETTINGS',
      icon: () => <TaxSettingsIcon selected={location.pathname.startsWith('/settings')} />,
      badge: printMessagesCount(
        getCombinedSettingsMessageCount(newMessagesCount, 'merchant_settings')
      ),
      selected: location.pathname.startsWith('/settings'),
      isTaxAgentMainVisible: false,
    },
  ].filter(Boolean)
}
